import { Stack, Typography } from "@mui/material";
import { Position } from "@xyflow/react";

import type { ActionRuleNode, RuleNodeProps } from "../types/nodes";
import AddConnectionHandle from "./AddConnectionHandle";
import AddHiddenHandle from "./AddHiddenHandle";
import BaseNode from "./BaseNode";

type ActionNodeProps = RuleNodeProps<ActionRuleNode>;

const ActionNode = (props: ActionNodeProps) => {
	return (
		<BaseNode {...props}>
			<Stack spacing={0.5}>
				<Typography variant="body2" color="text.primary">
					Action: Click
				</Typography>
			</Stack>
			<AddHiddenHandle type="target" position={Position.Top} id="in" />
			<AddConnectionHandle type="source" position={Position.Bottom} id="out" aria-label="Connect next step" />
		</BaseNode>
	);
};

export default ActionNode;
